import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { TeamworkCollectionPricingPageTemplate } from "@/templates/collections/teamwork/pricing/teamwork-collection-pricing-page.template.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface TeamworkCollectionPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<typeof pricingPageRelayQuery>;
}

export const TeamworkCollectionPricingPage = (
    props: TeamworkCollectionPricingPageProps
) => {
    const { pricingContent, pricing, countryCode, queryRef } = props;

    return (
        <PricingContentContextProviderRelay
            productId="teamwork-collection"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <TeamworkCollectionPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
